import { render, staticRenderFns } from "./AxiosLicenseView.vue?vue&type=template&id=67df57ac&scoped=true"
import script from "./AxiosLicenseView.vue?vue&type=script&lang=js"
export * from "./AxiosLicenseView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67df57ac",
  null
  
)

export default component.exports